<template>
    <div class="">
        <v-navigation-drawer v-model="dialog" fixed right touchless class="store-modal" :width="width" id="skinStore"
            :retain-focus="false" overlay-color="white" :overlay-opacity="0.9" stateless v-click-outside="{
                handler: clickOff,
                closeConditional: onClickOff
            }">


            <!-- nuevo contenido -->
            <v-container fill-height>
                <v-card class="mx-auto sidebar-card" v-if="buyData.value">
                    <v-row>
                        <v-col class="pb-0">
                            <div class="chip-wrap position-relative">
                                <v-img :src="require('@/assets/img/gamifications/tag--tienes.png')" height="36" width="80"
                                    contain class="coin-tag"></v-img>
                                <div class="coin-chip">
                                    <v-img :src="require('@/assets/img/icons/beecoins.png')" height="28" width="28"
                                        class="mr-1"></v-img>
                                    <span>{{ coins }}</span>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <!-- books -->
                    <v-row align="center" class="mx-0" v-if="buyData.isBook">
                        <v-col class="">
                            <v-img max-width="150" class="mx-auto"
                                :src="`https://assets.beeverso.org/lbr/image/${buyData.value.resourceDir}/cover_small.jpg`"></v-img>
                        </v-col>
                    </v-row>
                    <!-- books -->
                    <!-- avatares -->
                    <v-row justify="center" class="mx-0 px-0 pb-0 img-avatar" v-if="buyData.isAvatarPack">
                        <v-col cols="12">
                            <v-row justify="center" class="f-row">
                                <v-col cols="6">
                                    <img :src="`https://assets.beeverso.org/avatar/${buyData.value.avatarDTOList[0].name}/${buyData.value.avatarDTOList[0].value}`"
                                        class="avatar-img-top transition-all" alt="Av" width="100%" />
                                </v-col>
                            </v-row>
                            <v-row justify="center" class="s-row">
                                <v-col cols="6">
                                    <img :src="`https://assets.beeverso.org/avatar/${buyData.value.avatarDTOList[1].name}/${buyData.value.avatarDTOList[1].value}`"
                                        class="avatar-img-r transition-all" alt="Av" width="100%" />
                                </v-col>
                                <v-col cols="6">
                                    <img :src="`https://assets.beeverso.org/avatar/${buyData.value.avatarDTOList[2].name}/${buyData.value.avatarDTOList[2].value}`"
                                        class="avatar-img-l transition-all" alt="Av" width="100%" />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <!-- avatares -->

                    <!-- skins -->
                    <v-row justify="center" class="mx-0 px-0 my-xl-7" v-if="buyData.isSkin">
                        <v-img :src="`https://assets.beeverso.org/skins/${getThumbnail(buyData.value)}`" :height="imgSize"
                            :max-width="imgSize" class="ma-2 book-skin-img" />
                    </v-row>
                    <!-- skins -->
                    <v-row align="center" class="mx-0">
                        <v-col class="px-5">
                            <v-card elevation="0" class="sidebar-card-scroll py-3">
                                <!-- Is book -->
                                <template v-if="buyData.isBook">
                                    <v-card-title class="d-block justify-content-center pt-1">
                                        {{ buyData.value.title }}
                                    </v-card-title>
                                    <v-card-subtitle v-if="buyData.value.author">
                                        {{ buyData.value.author }}
                                    </v-card-subtitle>
                                    <v-card-text color="darkText" class="text-left py-0">
                                        <p>{{ buyData.value.bookAbstract }}</p>
                                    </v-card-text>
                                </template>
                                <!-- Is book -->

                                <v-card-title class="d-block justify-content-center pt-0" v-if="buyData.isAvatarPack">
                                    {{ $t('store.pack_of') }}
                                    {{ buyData.value.avatarDTOList.length }}
                                    {{ $t('store.avatars') }}
                                </v-card-title>
                                <v-card-title class="d-block justify-content-center pt-0" v-if="buyData.isSkin">
                                    {{ buyData.isBook ? buyData.value.title : buyData.value.name }}
                                </v-card-title>
                                <v-card-subtitle class="" v-if="buyData.isAvatarPack">
                                    {{ buyData.value.name }}
                                </v-card-subtitle>

                                <v-row class="coins-card mx-2 mt-3" v-if="!buyData.value.userPurchased">
                                    <v-col cols="3" offset="3" class="pr-0 pt-0">
                                        <v-img :src="require('@/assets/img/icons/beecoins.png')">
                                        </v-img>
                                    </v-col>
                                    <v-col class="d-flex flex-column justify-content-center text-start pl-0">
                                        <p class="text-h5 mb-0 font-weight-black line-height-100">
                                            {{ buyData.isAvatarPack ? packPrice : buyData.value.price }}
                                        </p>
                                        <p class="mb-0">BeeCoins</p>
                                    </v-col>
                                </v-row>
                                <v-row class="coins-card mx-2 mt-3" justify="center" align="center" v-else>
                                    <v-col cols="auto" class="pr-0 py-1">
                                        <v-img :src="require('@/assets/img/icons/check-stroke.png')"
                                            :max-width="!$vuetify.breakpoint.xs ? '60' : '42'"
                                            :max-height="!$vuetify.breakpoint.xs ? '60' : '42'">
                                        </v-img>
                                    </v-col>
                                    <v-col cols="auto" class="text-left pl-1">
                                        <!-- link a /user/books -->
                                        <a :href="`/user/book/${buyData.value.id}`">
                                            <p class="mb-0 font-weight-bolder">{{ $t('read') }}</p>
                                        </a>
                                    </v-col>
                                </v-row>
                                <v-row class="justify-content-center" v-if="buyData.isBook && !buyData.value.userPurchased">
                                    <!-- <v-chip label color="white" class="mr-1">
                                        <v-img
                                        :src="iconCategory"
                                        max-height="24"
                                        max-width="24"
                                        class="mr-1"
                                        ></v-img>
                                        Categoría
                                    </v-chip> -->
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                    <!-- books -->

                    <v-card-actions class="pb-5 pt-0">
                        <v-row class="px-0 px-md-3" justify="center" align="center" v-if="!buyData.value.userPurchased">
                            <v-col class="pa-0 pa-md-3" cols="4" offset="" v-if="buyData.isSkin">
                                <v-btn class="" fab dark color="white" depressed>
                                    <img :src="require('@/assets/img/icons/store/icon-preview.png')" alt="" srcset=""
                                        height="32" width="32" />
                                </v-btn>
                                <small class="text-nowrap">{{ $t('store.preview') }}</small>
                            </v-col>
                            <v-col class="pa-0 pa-md-3" cols="3">
                                <v-btn data-cy="buy-btn-store" class="" fab dark large color="primary" depressed @click="toBuy"
                                    :loading="btnLoading">
                                    <v-img contain height="32" width="32"
                                        :src="require('@/assets/img/icons/store/icon-buy-shadow.png')"></v-img>
                                </v-btn>
                                <br>
                                <strong><small class="text-primary text-nowrap">
                                        {{ $t('store.buy') }}
                                    </small></strong>
                            </v-col>
                        </v-row>

                        <v-alert :value="buyAlert" color="rgba(119, 100, 202, 0.7)" dark transition="scale-transition"
                            class="w-80">
                            <v-row data-cy="item_successfully_purchased">
                                <v-col class="pa-0">
                                    <v-img contain max-height="24" max-width="24"
                                        :src="require('@/assets/img/icons/store/icon-buy-shadow.png')"
                                        class="d-inline-flex align-middle alert-icon"></v-img>
                                    <span v-html="$t('store.item_successfully_purchased')"></span>
                                </v-col>
                            </v-row>
                        </v-alert>

                        <v-alert data-cy='inssuficient_beecoins-alert' :value="errorBuyAlert" color="rgba(214, 74, 59, 0.7)" dark transition="scale-transition"
                            class="w-80">
                            <v-row data-cy="insufficient-beecoins">
                                <v-col class="pa-0">
                                    <v-img contain max-height="24" max-width="24"
                                        :src="require('@/assets/img/icons/store/icon-no-buy-shadow.png')"
                                        class="d-inline-flex align-middle alert-icon"></v-img>
                                    <span data-cy="insufficient-beecoins" v-html="$t('store.insufficient_beecoins')"></span>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-card-actions>
                </v-card>
            </v-container>
            <!-- nuevo contenido -->
        </v-navigation-drawer>
        <v-overlay v-model="dialog" :opacity="0.9" color="white" fixed z-index="5"></v-overlay>
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import AvatarFavoriteService from '../../services/avatarFavorite'
import BookUserFavoriteService from '../../services/bookUserFavorite'
import GamificationService from '../../services/gamification'
import PurchaseService from '../../services/purchase'
import SkinFavoriteService from '../../services/skinFavorite'
import UserSkinService from '../../services/userSkin'

const defaultData = {
    isAvatarPack: false,
    isBook: false,
    isSkin: false,
    value: null
}

export default {
    props: {
        buyData: { type: Object, default: defaultData },
        dialog: { type: Boolean, default: false }
    },
    data() {
        return {
            bought: false,
            btnFavLoading: false,
            btnLoading: false,
            favorite: false,
            imgSize: 300,
            reload: 0,
            selectedSkin: {},
            priceIconSize: 300,
            windowSize: {
                x: 0,
                y: 0
            },
            buyAlert: false,
            errorBuyAlert: false,
            selectedSkin: null,
        }
    },
    mounted() {
        this.onResize()
    },
    computed: {
        ...mapState({
            userId: (state) => state.userData.user.id,
            coins: (state) => state.userData.coins,
            user: (state) => state.userData.user,
        }),
        buyText() {
            if (this.buyData.isAvatarPack) return this.$t('store.buy_this_pack')
            if (this.buyData.isBook) return this.$t('store.buy_this_book')
            return this.$t('store.buy_this_skin')
        },
        packPrice() {
            let price = 0
            this.buyData.value.avatarDTOList.forEach(element => {
                price += element.price
            });
            return price
        },
        priceText() {
            if (this.buyData.isAvatarPack) return this.$t('store.this_pack')
            if (this.buyData.isBook) return this.$t('store.this_book')
            return this.$t('store.this_skin')
        },
        bookOrSkinPrice() {
            return this.buyData.value ? this.buyData.value.price : 0
        },
        width() {
            if (this.$vuetify.breakpoint.xs) {
                return 320
            }
            if (this.$vuetify.breakpoint.sm) {
                return 360
            }
            if (this.$vuetify.breakpoint.lg) {
                return 380
            }
            if (this.$vuetify.breakpoint.xl) {
                return 400
            }
            return 380
        },
    },
    methods: {
        ...mapActions('userData', [
            'setGamification',
        ]),
        closeModal() {
            this.$emit('close', this.bought)
            this.bought = false
        },
        clickOff() {
            console.log('clickOff')
            this.closeModal()
        },
        onClickOff() {
            return this.dialog
        },
        async getGamification() {
            GamificationService.getUserGameStatsByUser(
                this.userId
            )
                .then((response) => {
                    if (response.content.id) {
                        this.setGamification(response.content)
                    }
                })
                .catch((error) => console.error(error))
        },
        getThumbnail(skin) {
            const img = skin.resources.find((res) => res.resourceUrl.includes('thumbnail'))
            return img.resourceUrl
        },
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if (this.windowSize.y < 725) {
                this.imgSize = 220
                this.priceIconSize = 180
                return
            }
            if (this.windowSize.y < 835) {
                this.imgSize = 220
                this.priceIconSize = 220
                return
            }
            this.imgSize = 280
            this.priceIconSize = 280
        },
        async setFavorite() {
            this.btnFavLoading = true
            this.favorite = !this.favorite
            if (this.buyData.isAvatarPack) {
                await this.setFavoriteAvatarPack()
            }
            if (this.buyData.isBook) {
                await this.setFavoriteBook()
            }
            await this.setFavoriteSkin()
            this.btnFavLoading = false
        },
        async setFavoriteAvatarPack() {
            if (this.favorite) {
                await AvatarFavoriteService.createFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                    .catch((error) => console.error(error))
            } else {
                await AvatarFavoriteService.deleteFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                    .catch((error) => console.error(error))
            }
            this.$emit('favorite', 0)
        },
        async setFavoriteBook() {
            if (this.favorite) {
                await BookUserFavoriteService.addFavoriteBookToUser({
                    user: { id: this.userId },
                    book: { id: this.buyData.value.id }
                })
                    .catch((error) => console.error(error))
            } else {
                await BookUserFavoriteService.deleteFavoriteBookToUser(
                    this.userId,
                    this.buyData.value.id
                )
                    .catch((error) => console.error(error))
            }
            this.$emit('favorite', 1)
        },
        async setFavoriteSkin() {
            if (this.favorite) {
                await SkinFavoriteService.createFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                    .catch((error) => console.error(error))
            } else {
                await SkinFavoriteService.deleteFavorite(
                    this.userId,
                    this.buyData.value.id
                )
                    .catch((error) => console.error(error))
            }
            this.$emit('favorite', 2)
        },
        async toBuy() {
            if (this.coins > (this.buyData.isAvatarPack ? this.packPrice : this.bookOrSkinPrice)) {
                this.btnLoading = true
                this.bought = true
                if (this.buyData.isAvatarPack) {
                    await PurchaseService.createPurchaseAvatarPack(
                        this.userId,
                        this.buyData.value.id
                    )
                        .catch((error) => console.error(error))
                }
                if (this.buyData.isBook) {
                    await PurchaseService.createPurchaseBook(
                        this.userId,
                        this.buyData.value.id
                    )
                        .catch((error) => console.error(error))
                }
                if (this.buyData.isSkin) {
                    await PurchaseService.createPurchaseSkin(
                        this.userId,
                        this.buyData.value.id
                    )
                        .catch((error) => console.error(error))
                }
                await this.getGamification()
                this.buyAlert = true
                setTimeout(() => {
                    this.buyAlert = false
                }, 3000)
            } else {
                this.errorBuyAlert = true
                setTimeout(() => {
                    this.errorbuyAlert = false
                }, 3000)
            }
            this.btnLoading = false
            setTimeout(() => {
                this.closeModal()
            }, 3000)
        },
        setDesktop(skin) {
            if (!skin) {
            return
            }
            const img = skin.resources.find((res) => res.resourceUrl.includes('desktop'))
            const cardBanner = document.getElementById('skinStore')
            cardBanner.style.backgroundImage = `url("https://assets.beeverso.org/skins/${img.resourceUrl}")`
        },
        getSelectedSkin() {
            UserSkinService.getSelectedByUser(this.user.id)
            .then((response) => {
                this.selectedSkin = response.content
                this.setDesktop(response.content)
            })
            .catch((error) => console.error(error))
        },
    },
    created() {
      this.getSelectedSkin()
    },
    watch: {
        dialog() {
            if (this.dialog) {
                this.favorite = this.buyData.value.favorite
            }
        }
    },
    created() {
      this.getSelectedSkin()
    },
}
</script>

<style lang="scss" scoped>
.store-modal{
    background-size: cover;
}
.sidebar {
    &.v-navigation-drawer {
        box-shadow: 4px 0px 50px rgba(0, 0, 0, 0.05);

        @media (max-width: 599px) {
            height: calc(100vh - 50px) !important;
        }
    }

    &-card {
        border-radius: 1rem;
        background-color: rgba(255, 255, 255, 0.8);
        position: relative;

        &:before {
            content: '';
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            backdrop-filter: blur(6px);
            border-radius: 1rem;
            z-index: -1;
        }

        .v-btn {
            &:not(.primary) {
                color: #4B5768;
            }

            &.primary {
                background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
                box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);

                &+span {
                    color: #7764CA;
                    font-weight: 600;
                }
            }

            &+span {
                white-space: nowrap;
                font-size: .85rem;
            }

            @media (max-width: 600px) {
                &.v-btn--fab.v-btn--round:not(.primary) {
                    &+span {
                        font-size: .85rem;
                    }
                }
            }
        }

        &-scroll {
            background-color: rgba(255, 255, 255, 0.45);
            border-radius: .5rem;

            .v-card {
                &__title {
                    word-break: keep-all;
                    line-height: 130%;
                }

                &__text {
                    height: auto;
                    max-height: 7rem;
                    overflow-y: auto;
                    @media screen and (max-height: 768px) {
                        max-height: 4rem;
                    }
                    p {
                        margin-bottom: 0;

                        &+p {
                            margin-top: 16px;
                        }
                    }

                    &::-webkit-scrollbar-track {
                        background-color: rgba(50, 58, 70, 0.2);
                    }

                    &::-webkit-scrollbar {
                        width: 0.5em;
                        height: 0.5em;
                    }

                    &::-webkit-scrollbar-thumb {
                        background-color: rgba(50, 58, 70, 1);
                        border-radius: 3px;
                    }
                }
            }

            .v-btn {
                background-color: white;
                text-transform: none;

                @media (max-width: 599px) {
                    font-size: .75rem;
                }
            }
        }
    }
}

.v-item-group {
    .v-chip:hover:before {
        opacity: 0;
    }
}

.v-alert {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}

.text-primary {
    color: rgba(119, 100, 202, 1);
}

.coins-card {
    background: white;
    border-radius: 8px;
}

.coin-chip {
    align-items: center;
    background: white;
    border-radius: 8px;
    color: #323A46;
    display: inline-flex;
    font-weight: 700;
    margin-right: 15px;
    padding: 8px 12px;

    .v-image {
        display: inline-flex;
    }
}

.coin-tag {
    display: inline-flex;
    right: -15px;
    position: relative;
    top: 3px;
}

.f-row {
    height: 45%;
    position: relative;
    z-index: 1;
}

.s-row {
    height: 45%;
    margin-top: -60px;
}

.img-avatar {
    max-height: 280px;
}

.alert-icon {
    margin: -3px 4px 0 0;
}
.store-modal{
    background-size: cover;
}
</style>
